var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$vuetify.breakpoint.xs)?_c('span',{staticClass:"backdrop-name font-weight-black display-4 px-12 py-6"},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }